import { type AccountAction, useAccountDialog } from "./account-dialog";
import { useSession } from "./queries";

/**
 * Wraps an action that needs a full account, such as voting or reporting. Someone without one
 * stays on the page and gets the account dialog, titled with what they tried: a signed-out reader
 * signs in and comes back, and a guest creates an account in place.
 * Until the session is known the press does nothing, rather than guess someone is signed out.
 */
export function useAccountAction(reason: AccountAction): (action: () => void) => void {
  const { data: session } = useSession();
  const { openAccountDialog } = useAccountDialog();

  return action => {
    if (session === undefined) return;
    if (session && !session.user.isAnonymous) action();
    else openAccountDialog(reason);
  };
}
